import { format } from 'date-fns';

/**
 * Parse time string (HH:mm:ss or HH:mm) and return hours and minutes
 */
export const parseTime = (timeStr: string | undefined): { hours: number; minutes: number } => {
  if (!timeStr) return { hours: 0, minutes: 0 };
  const parts = timeStr.split(':');
  return {
    hours: parseInt(parts[0] || '0', 10),
    minutes: parseInt(parts[1] || '0', 10),
  };
};

/**
 * Convert time string from "HH:mm:ss" to "HH:mm" for time input
 * Used when converting from backend time strings to HTML5 time input format
 */
export const formatTimeStringForInput = (timeStr: string | undefined): string => {
  if (!timeStr) return '';
  // Handle both "HH:mm:ss" and "HH:mm" formats
  return timeStr.substring(0, 5);
};

/**
 * Convert Date object to "HH:mm" format for time input
 * Used when converting Date objects to HTML5 time input format
 */
export const formatDateForTimeInput = (date: Date): string => {
  return format(date, 'HH:mm');
};

/**
 * Parse HH:mm time string and return a Date object for the given base date
 * Used when parsing HTML5 time input values back to Date objects
 */
export const parseTimeInput = (timeStr: string, baseDate: Date): Date | null => {
  if (!timeStr || timeStr.trim() === '') return null;
  const parts = timeStr.split(':');
  if (parts.length < 2) return null;
  const hours = parseInt(parts[0] || '0', 10);
  const minutes = parseInt(parts[1] || '0', 10);
  if (isNaN(hours) || isNaN(minutes)) return null;
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
  const result = new Date(baseDate);
  result.setHours(hours, minutes, 0, 0);
  return result;
};
